import { render, staticRenderFns } from "./FollowAdjuster.vue?vue&type=template&id=4b3bd5df&scoped=true"
import script from "./FollowAdjuster.vue?vue&type=script&lang=js"
export * from "./FollowAdjuster.vue?vue&type=script&lang=js"
import style0 from "./FollowAdjuster.vue?vue&type=style&index=0&id=4b3bd5df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3bd5df",
  null
  
)

export default component.exports